import { Message } from '@twilio/conversations';

import { SnModel } from '@lib/common/models';

export class SnMessage extends SnModel {
  public mediaSource: string;

  public extMessage: boolean = false;
  public organization: string;

  constructor(public readonly twilio: Message) {
    super();
  }

  get id(): string {
    return this.twilio.sid;
  }
}
